import * as actions from './Infographics.actions';
import * as selectors from './Infographics.selectors';
import reducer from './Infographics.reducer';

export default {
  actions,
  reducer,
  selectors,
};
